import React from 'react';
import Slide from '@material-ui/core/Slide';

function BaseStepper(props) {
    return (
        <Slide
            direction="left"
            in
            timeout={500}
        >
            <div className="demo-container mdl-grid">
                <div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
                <div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
                    <div className="mdl-grid">
                        <div className="mdl-cell mdl-cell--12-col center-items display-block">
                            {/* Heading */}
                            { props.heading }
                        </div>
                    </div>
                    <div className="mdl-grid center-items">
                        {/* content */}
                        { props.children }
                    </div>
                    {/* Buttons */}
                    { props.buttons }
                </div>
            </div>
        </Slide>
    );
}

export default BaseStepper;
